// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.wallet.client

import org.multipaz.cbor.DataItem
import org.multipaz.wallet.client.DocumentPreconsentSetting.RequestComplexityBased
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.cbor.Tstr
import org.multipaz.documenttype.DocumentAttributeSensitivity

fun RequestComplexityBased.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "o-IEj4bd9fhsfPhnEOcyk3dmXU06igyhjfz7jh4UA5Q")
val RequestComplexityBased_cborSchemaId = ByteString(-93, -30, 4, -113, -122, -35, -11, -8, 108, 124, -8, 103, 16, -25, 50, -109, 119, 102, 93, 77, 58, -118, 12, -95, -115, -4, -5, -114, 30, 20, 3, -108)

fun RequestComplexityBased.toDataItem(): DataItem {
    val builder = CborMap.builder()
    builder.put("type", "RequestComplexityBased")
    builder.put("approvedSensitivity", Tstr(this.approvedSensitivity.name))
    return builder.end().build()
}

fun RequestComplexityBased_fromDataItem(dataItem: DataItem): RequestComplexityBased {
    val approvedSensitivity = DocumentAttributeSensitivity.valueOf(dataItem["approvedSensitivity"].asTstr)
    return RequestComplexityBased(
        approvedSensitivity = approvedSensitivity,
    )
}
